import React from "react"
import PropTypes from "prop-types"

// Components
import Tabs from "../components/Tabs/Tabs"
import { Panel } from "../components/Panel/Panel"
import AnalyzeRisksContent from "./AnalyzeRisksContent"
import ErrorState from "../components/ErrorState/ErrorState"

// Utils
import { dashToTitleCase } from "../components/utils"

const AnalyzeRisks = props => {
  const { scoresDistributions, monthlyScore, behaviorTypes, callData } = props

  if (
    behaviorTypes.length &&
    Object.keys(scoresDistributions).length &&
    monthlyScore
  ) {
    return (
      <Tabs callData={callData} tabActive={1}>
        {behaviorTypes.map(behaviorType => (
          <Panel key={behaviorType} title={dashToTitleCase(behaviorType)}>
            <AnalyzeRisksContent
              scoresDistributions={scoresDistributions}
              monthlyScore={monthlyScore}
              behaviorType={behaviorType}
            />
          </Panel>
        ))}
      </Tabs>
    )
  }
  return (
    <div className="center-text">
      <ErrorState />
    </div>
  )
}

export default AnalyzeRisks

AnalyzeRisks.propTypes = {
  scoresDistributions: PropTypes.shape({}),
  monthlyScore: PropTypes.arrayOf(PropTypes.shape()),
  behaviorTypes: PropTypes.arrayOf(PropTypes.string),
  callData: PropTypes.bool
}

AnalyzeRisks.defaultProps = {
  scoresDistributions: {},
  monthlyScore: null,
  behaviorTypes: [],
  callData: true
}
